import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

import { SquaredButton, Text, Icon } from 'ui-redesign/elements';
import { Paging, Loading, ReviewContent, ReviewFooter } from 'ui-redesign/components';

import {
  ReviewList,
  ReviewItem,
  Review,
  CustomerInfo,
  CustomerAvatar,
  CustomerInfoContent,
  ReviewListHeader,
  ProductInfo,
} from '../ReviewsAndQuestions.styled';
import ModalReview from './modal-review/ModalReview';

import { ReactComponent as Check } from 'ui-redesign/elements/icon/assets/circle-check.svg';

import {
  productMap,
  getReviewsById,
  getTotalReviews,
  fetchReviews,
  YOTPO_GLOW_RINGS_ID,
  YOTPO_FARMSTAND_ID,
} from 'redux/userGenerated/userGenerated';
import { formatShortDate } from 'utils/date-utils';

const PAGE_SIZE = 5;

const ReviewListComponent = ({ history, productId, openReviewForm }) => {
  const [modalContent, setModalContent] = useState(null);
  const reviews = useSelector((state) => getReviewsById(state, productId));
  const totalReviews = useSelector((state) => getTotalReviews(state, productId));
  const page = parseInt(queryString.parse(history.location.search)?.page) || 1;
  const isLoading = useSelector((state) => state.userGenerated.loading.reviews);
  const dispatch = useDispatch();

  useEffect(() => {
    if (productId) {
      dispatch(fetchReviews(productId, PAGE_SIZE, page));
    } else {
      dispatch(fetchReviews(YOTPO_FARMSTAND_ID, PAGE_SIZE, page));
      dispatch(fetchReviews(YOTPO_GLOW_RINGS_ID, PAGE_SIZE, page));
    }
    /* eslint-disable-next-line */
  }, [dispatch, page]);

  const onClosePictureModal = () => setModalContent(null);

  // no reviews yet to list
  if (!isLoading && _isEmpty(reviews)) return <SquaredButton label='BE THE FIRST TO WRITE A REVIEW' onClick={openReviewForm} />;

  if (isLoading && _isEmpty(reviews)) return <Loading />;
  return (
    <>
      <ReviewListHeader>
        <Text modifiers={['brandFont']} content={`${totalReviews} Reviews`} />
      </ReviewListHeader>
      <ReviewList>
        {reviews.map((review) => {
          return (
            <ReviewItem key={review.id}>
              <Review>
                <CustomerInfo>
                  <CustomerAvatar>
                    <Text
                      modifiers={['noLineHeight', 'noLetterSpace', 'brandFont']}
                      content={review.user?.display_name?.substring?.(0, 1)}
                    />
                    {review.reviewer_type === 'verified_reviewer' && (
                      <Icon>
                        <Check />
                      </Icon>
                    )}
                  </CustomerAvatar>
                  <CustomerInfoContent>
                    <Text modifiers={['noLineHeight', 'brandColor']} content={review.user?.display_name} />
                    <Text modifiers={['noLineHeight', 'brandFont']} content={formatShortDate(review.created_at)} />
                    <ProductInfo>
                      <Text content='Product:' modifiers='brandFont'></Text>
                      <Text modifiers={['noLineHeight', 'brandFont', 'light']} content={productMap[review.product_id].title} />
                    </ProductInfo>
                  </CustomerInfoContent>
                </CustomerInfo>
                <ReviewContent review={review} setModalContent={setModalContent} />
                <ReviewFooter id={review.id} votesUp={review.votes_up} votesDown={review.votes_down} />
              </Review>
            </ReviewItem>
          );
        })}
      </ReviewList>
      {totalReviews > PAGE_SIZE && (
        <Paging pageSize={PAGE_SIZE} total={totalReviews} currentPage={page} baseRoute={`${history.location.pathname}?page=`} />
      )}
      {!!modalContent && <ModalReview content={modalContent} onClose={onClosePictureModal} productMap={productMap} />}
    </>
  );
};

ReviewListComponent.propTypes = {
  history: PropTypes.object,
  productId: PropTypes.oneOf(Object.keys(productMap)),
  openReviewForm: PropTypes.func.isRequired,
};
export default ReviewListComponent;
